module.exports = __webpack_public_path__ + "img/title-bg.173afed1.png";